<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 p-0">
            <div id="login" class="background d-none d-md-block d-lg-block d-xl-block">
            </div>
          </div>
          <div class="col-12 col-md-6" style="display: flex; align-items: center; justify-content: center;">
            <div class="form">
              <img src="logo_ecoverse.png" height="150" width="160"/>
              <h2 class="title black-title">Login</h2>
              <input type="text" id="femail" name="femail" placeholder="Email" v-model.trim="email" v-on:keyup.enter="login"><br><br>
              <input type="password" id="fpassword" name="fpassword" placeholder="Password" v-model.trim="password" v-on:keyup.enter="login"><br><br>
              <button class="btn-general-black" type="button" @click="login" :disabled="loading">Login<span v-if="loading">...</span></button>
              <div v-if="errorMsg !== ''" class="text-danger mt-1">{{ errorMsg }}</div>
              <div class="mt-4"><router-link class="password-reset" :to="{path:'/register'}">I do not have an account</router-link></div>
              <div class=""><router-link class="password-reset" :to="{path:'/reset_password'}">I forgot my password</router-link></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      errorMsg: "",
      loading: false,
      redirectApp: (this.$route.query.rapp && this.$route.query.rapp !== '') ? this.$route.query.rapp.trim() : null,
      redirectUrl: (this.$route.query.rurl && this.$route.query.rurl !== '') ? this.$route.query.rurl.trim() : null,
    };
  },
  methods: {
    login () {
      if (this.email === "" || this.password === "") {
        return false;
      }
      let self = this;
      self.loading = true;
      Api.send("POST", "/user/login", {email: this.email, password: this.password}, false)
      .then((response) => {
        self.errorMsg = "";
        self.$root.setLoggedUser(response.data);
        if (self.$root.canUserDo(['ecoverse_access'])) {
          self.$router.push({name: 'home'}) 
        } else {
          self.$root.deleteLoggedUser();
        }
      })
      .catch((err) => {
        self.errorMsg = err.msg;
      })
      .finally(() => {
        self.loading = false;
      });
    },
  },
};
</script>
<style scoped>
h1,h2,h3,h4,h5,h6,p, button{
      color:white;
      font-family: "Poppins";
}

 h6 {
     font-size: 14px; 
     font-weight: 200;
}

.background {
    height: 100vh;
    background-size: cover;
    background-position: center;
}

.btn-general {
    border: 2px solid white;
    padding: 5px 65px 5px 65px;
    background: none;
}

.btn-general:hover {
    border: 2px solid #f0f0f0;
    color: #f0f0f0;
    cursor: pointer;
}

.btn-general-black{
    border: 2px solid black;
    padding: 5px 105px 5px 105px;
    background: none;
    color: black;
    margin-top: 30px;
}

.btn-general-black:hover {
    border: 2px solid #959393;
    color: #959393;
    cursor: pointer;
}

.black {color:black;}

.same-line{white-space: nowrap;}
#login {background-image: url("/register.jpg");}
.title{
    font-size: 25px;
    
}
.form {
    width: 100%;
    margin: 0;
    text-align: center;
}
.form input{
    width: 90%;
    max-width: 400px;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 0.2px solid #959393;
    color: #959393;
    font-weight: 100;
    font-size: 18px;
}
.black-title {
    color: black;
    
}
.form h6 {margin-bottom: 50px;}
.form img {
    margin-bottom: 35px;
}
.password-reset {
    color: #959393;
    font-size: 16px;
    font-weight: 100;
}
</style>
